export default {
	type: 'ARTICLE_SUBSCRIPTIONS',
	name: 'Subscriptions',
	allowedSections: ['article', 'main'],
	disallowedChildren: ['*'],
	category: 'Article',
	props: [{
		name: 'Header',
		inputType: 'text',
		label: 'Header'
	}, {
		name: 'goToCheckout',
		inputType: 'checkbox',
		label: 'Go to checkout after add',
		default: false
	}],
	hiddenProps: [{
		label: 'Description settings',
		props: [{
			name: 'showDescription1',
			inputType: 'checkbox',
			label: 'Show description 1',
			default: true
		}, {
			name: 'showDescription2',
			inputType: 'checkbox',
			label: 'Show description 2',
			default: true
		}, {
			name: 'showDescription3',
			inputType: 'checkbox',
			label: 'Show description 3',
			default: true
		}, {
			name: 'showPrice',
			inputType: 'checkbox',
			label: 'Show price',
			default: true
		}]
	}, {
		label: 'Button settings',
		props: [{
			name: 'buttonText',
			inputType: 'text',
			label: 'Button text',
			default: 'Add to cart'
		}]
	}, {
		label: 'Advanced settings',
		props: [{
			name: 'class',
			inputType: 'text',
			label: 'CSS-class',
			default: ''
		}]
	}, {
		label: 'Out of stock settings',
		props: [{
			name: 'outOfStockButtonText',
			inputType: 'text',
			label: 'Button Text',
			default: 'Out of stock'
		}, {
			name: 'hideOutOfStockButton',
			inputType: 'checkbox',
			label: 'Hide button',
			default: false
		}, {
			name: 'outOfStockMessage',
			inputType: 'text',
			label: 'Out of stock message',
			default: ''
		}]
	}]
};
